// https://app.growthbook.io/features/pen-6957_v2
export const PEN_6957_V2_CM_SKINNY_CM_FLAG = 'pen-6957_v2'

// Tracking location shared across all Skinny CM modal events.
export const SKINNY_CM_LOCATION = 'skinny_cm_modal'

// Footer height (px). The screen area reserves this much space at the bottom so
// content never sits under the sticky footer. Mobile pins the bar to this
// height; desktop sizes to its content via padding (see StickyFooter) and this
// stays the space the body reserves.
export const SKINNY_CM_FOOTER_HEIGHT = 86

// Shared desktop content gutter: a 1210px max-width content column centered in
// the viewport (≈115px gutters at 1440, per Figma), clamped to a 16px min on
// narrower desktops. Applied to the back button, the story body, and the footer
// so all three align to the same column edge instead of drifting on ad-hoc px.
export const SKINNY_CM_DESKTOP_GUTTER = 'max(16px, calc((100% - 1210px) / 2))'

// Brand accent (answer numbers, headline accent, footer) and the condensed
// display font used for nameplates and quiz numbers.
export const CM_PRIMARY = '#e60c49'
export const SOHNE_SCHMAL = "'Sohne Schmal', Impact, sans-serif"
